import { render, staticRenderFns } from "./PersonalDataTab.vue?vue&type=template&id=cc5650f2&scoped=true"
import script from "./PersonalDataTab.vue?vue&type=script&lang=js"
export * from "./PersonalDataTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5650f2",
  null
  
)

export default component.exports